import React from "react";
import {
  EditOutlined,
  ScanOutlined,
  ExperimentOutlined,
  TeamOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

const JobPostListingHeroSection: React.FC = () => {
  return (
    <section className="job-listing__hero">
      <div className="job-listing__hero-inner">
        <h1 className="job-listing__hero-title">
          Your Next{" "}
          <span className="job-listing__hero-highlight">Big Opportunity</span>{" "}
          Awaits
        </h1>
        <p className="job-listing__hero-sub">
          A straightforward hiring process designed for clarity and your
          success.
        </p>
        <div className="job-listing__timeline">
          <div className="job-listing__timeline-item">
            <div className="job-listing__timeline-icon">
              <EditOutlined />
            </div>
            <h3 className="job-listing__timeline-title">Apply</h3>
            <p className="job-listing__timeline-desc">Share your story</p>
          </div>
          <div className="job-listing__timeline-line" aria-hidden />
          <div className="job-listing__timeline-item">
            <div className="job-listing__timeline-icon job-listing__timeline-icon--badge">
              <ScanOutlined />
              <span className="job-listing__timeline-badge">AI</span>
            </div>
            <h3 className="job-listing__timeline-title">Screening</h3>
            <p className="job-listing__timeline-desc">Skills matching</p>
          </div>
          <div className="job-listing__timeline-line" aria-hidden />
          <div className="job-listing__timeline-item">
            <div className="job-listing__timeline-icon job-listing__timeline-icon--badge">
              <ExperimentOutlined />
              <span className="job-listing__timeline-badge">AI</span>
            </div>
            <h3 className="job-listing__timeline-title">Assessment</h3>
            <p className="job-listing__timeline-desc">Showcase expertise</p>
          </div>
          <div className="job-listing__timeline-line" aria-hidden />
          <div className="job-listing__timeline-item">
            <div className="job-listing__timeline-icon">
              <TeamOutlined />
            </div>
            <h3 className="job-listing__timeline-title">Interview</h3>
            <p className="job-listing__timeline-desc">Meet the team</p>
          </div>
          <div className="job-listing__timeline-line" aria-hidden />
          <div className="job-listing__timeline-item">
            <div className="job-listing__timeline-icon">
              <TrophyOutlined />
            </div>
            <h3 className="job-listing__timeline-title">Offer</h3>
            <p className="job-listing__timeline-desc">Welcome!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobPostListingHeroSection;
